import React, { Fragment, useContext, useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Dict, IOrgStageCoordsGetterOutput } from '../functions/getOrgStages-1'
import { D3Rect } from '../../D3Components/D3Rect'
import { constants } from '../../../Constants'
import { getIDs } from '../functions/getID'
import D3Line from '../../D3Components/D3Line'
import RootStoreContext from '../../../storage/RootStore'

interface BlocksProps extends IOrgStageCoordsGetterOutput { }

export const Blocks: React.FC<BlocksProps> = observer(({
    orgStagesCoords, arrayOrgNodes, connectionDotsCoords, arrayStages
}) => {

    const { selection } = useContext(RootStoreContext)

    const { BLOCK, HIGHLIGHT_LINE, GRID } = constants

    const rendered = useMemo(() => {
        let b: { [orgStageID: string]: { x: number, y: number, selectable: boolean } } = {}

        if (arrayOrgNodes){
            arrayOrgNodes.map((row, rowIndex) => {
                const orgID = row[0]
    
                row.map((cell, cellIndex) => {
                    const stageID = arrayStages[cellIndex]
                    const orgStageID = `${orgID}-${stageID}`
                    b[orgStageID] = { x: BLOCK.WIDTH * cellIndex, y: BLOCK.HEIGHT * rowIndex, selectable: orgStagesCoords.hasOwnProperty(orgStageID) && orgStagesCoords[orgStageID].node }
                    return null
                })
                return null
            })
        }

        return b
    }, [arrayOrgNodes, arrayStages, BLOCK.WIDTH, BLOCK.HEIGHT, orgStagesCoords])


    return <Fragment>

        <g id='blocks'>
            {Object.keys(rendered).map(orgStageID => {
                const { orgID, stageID, stageIndex } = getIDs(orgStageID)
                const { x, y, selectable } = rendered[orgStageID]

                const color = (stageIndex + 1) % 2 === 0 ? 'transparent' : BLOCK.BG_ODD

                const lines = {
                    horizontal: false,
                    vertical: false
                }


                //// Skipping when stageIndex is not assigned
                if (isNaN(stageIndex)) return null



                return (
                    <g data-stage-index={stageIndex} data-id={orgStageID} data-stage={stageID} data-org={orgID} >

                        {/*  Pseudo-block */}
                        <D3Rect
                            key={orgStageID}
                            x={x} y={y}
                            width={BLOCK.WIDTH}
                            height={BLOCK.HEIGHT}
                            labelAlign={"center"}
                            rectColor={color}
                            rectBorderColor={`transparent`}
                            cursor={selectable ? 'pointer' : 'auto'}
                            onClick={() => selectable ? selection.setOrgStage(orgStageID) : null}
                            styles={{ cursor: 'pointer' }}
                        />

                        {/* Горизонтальні лінії посередині блоку */}
                        {(lines.horizontal || orgID === selection.org) && <D3Line

                            from={[
                                x,
                                y + BLOCK.HEIGHT / 2
                            ]}
                            to={[
                                x + BLOCK.WIDTH,
                                y + BLOCK.HEIGHT / 2
                            ]}
                            strokeColor={orgID === selection.org ? HIGHLIGHT_LINE.COLOR.HORIZONTAL : GRID.COLOR}
                            strokeWidth={orgID === selection.org ? HIGHLIGHT_LINE.WIDTH.HORIZONTAL : GRID.WIDTH}
                            strokeOpacity={orgID === selection.org ? HIGHLIGHT_LINE.OPACITY.HORIZONTAL : GRID.OPACITY}
                        />}

                        {/* Вертикальні лінії посередині блоку */}
                        {(lines.vertical || stageID === selection.stage) && <D3Line
                            from={[
                                x + 0.5 * BLOCK.WIDTH,
                                y
                            ]}
                            to={[
                                x + 0.5 * BLOCK.WIDTH,
                                y + BLOCK.HEIGHT
                            ]}
                            strokeColor={stageID === selection.stage ? HIGHLIGHT_LINE.COLOR.VERTICAL : GRID.COLOR}
                            strokeWidth={stageID === selection.stage ? HIGHLIGHT_LINE.WIDTH.VERTICAL : GRID.WIDTH}
                            strokeOpacity={stageID === selection.stage ? HIGHLIGHT_LINE.OPACITY.VERTICAL : GRID.OPACITY}
                        />}
                    </g>)
            })}
        </g>
    </Fragment>
})
